import React from 'react';
import Typography from '../../../ui/Typography/Typography';
import Button from '../../../ui/Button/Button';
import './Card.css';

const birthdayCardContent = {
    title: 'Happy Birthday!',
    intro: 'To my favorite person in the world!',
    message: `Happy birthday, my cutie, my princess, my teme, my baby ❤️. I wish you the best 27th birthday ever and I'm so happy I'm here to celebrate it with you!

You have made my life much brighter and more colorful, whether it's through your eccentrically cute antics or your willingness to try new things. Without you, I don't think I would've done the Manhattan walk, nor went up to Catskill for a cabin getaway. There's so many more things you have opened my eyes to, and I'm so glad to have you in my life.

Even though you're the bubbly baby on the outside, in the inside, you're one of the most mature person I know. I love how we tackle challenges in our relationship (albeit few yayy), and I always come out content in how we deal with things. You always look for ways to make our lives better, and I really appreciate you doing so!

I really want to convey it through this digital scrapbook. I didn't want a physical copy of a scrapbook where we would fill up the pages, then have to get another one, and also be unable to edit nor change the pictures that we had in our past. I want us to have an dynamic journal of our lives together, one where we can collaborate and build upon together :)

I love you so much baby, and here's to Jeremy Bearimy more years of being soulmates ❤️`
};

interface BirthdayCardProps {
  onClose: () => void;
  titleId: string;
}

export const BirthdayCard: React.FC<BirthdayCardProps> = ({ onClose, titleId }) => {
  return (
    <>
      <div className="birthday-card-header">
        <Typography id={titleId} variant="h1" className="birthday-card-title">
          {birthdayCardContent.title}
        </Typography>
        <Button
          variant="close"
          size="small"
          onClick={onClose}
          className="birthday-card-close"
          aria-label="Close birthday card"
        >
          ×
        </Button>
      </div>
      {/* Focusable so the D-pad scrolls the story text. */}
      <div className="birthday-card-content" tabIndex={0} aria-label="Story text">
        <Typography variant="body1" className="birthday-card-intro">
          {birthdayCardContent.intro}
        </Typography>
        <div className="birthday-card-section">
          <Typography variant="body1" className="birthday-card-section-body">
            {birthdayCardContent.message}
          </Typography>
        </div>
      </div>
    </>
  );
};
